<div class="wz-full-container animated fadeIn">
  <wz-page-header [backLink]="backLink" *ngIf="wzTitle || title; else header">
    <wz-page-title> {{ wzTitle || title }}</wz-page-title>
  </wz-page-header>
  <ng-template #header>
    <ng-content select="wz-page-header"></ng-content>
  </ng-template>
  <ng-content></ng-content>
</div>
